module.exports = __webpack_public_path__ + "img/btc.ef11a598.svg";